module.exports = __webpack_public_path__ + "static/img/urgentnotice1.d181b8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/urgentnotice1.jpg
// module id = AG6B
// module chunks = 0